import React from "react";
import { Button } from "react-bootstrap";
import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import "./PreForm.scss";
import { SwitchRadioField } from "../../../../../CaseGenerator/FormFields";
import { TranslatedText } from "../../../../../../helpers/helpers";
import { PaymentType } from "../../../../../../helpers/enums";
const PreForm = (props) => {
  const { t } = useTranslation();

  return (
    <div className="PreForm" data-testid="PreForm">
      <div className="pre-step-form  col-md-12">
        <div className="row my-5">
          <div className="col">
            <h3 className="form-section-title">
              <TranslatedText i18nKey="cases.analisi_acqua.pre_step_form.title" />
            </h3>
            <p className="description my-4">
              <TranslatedText i18nKey="cases.analisi_acqua.pre_step_form.description" />
            </p>
          </div>
        </div>
        <Formik
          initialValues={{ paymentType: '' }}
          validationSchema={Yup.object().shape({
            paymentType: Yup.string()
              .oneOf(
                Object.values(PaymentType).map((option) => option),
                <TranslatedText i18nKey="common.errors.notValid" />
              )
              .required(
                <TranslatedText i18nKey="cases.request_info.errors.required" />
              ),
          })}
          onSubmit={(values, actions) => {
            props.handleContinue(values, actions);
            const eventPaymentType = {
              BANK_TRANSFER: 'Bonifico',
              CREDIT_CARD: 'Carta'
            }
            window.dataLayer.push({"event": "modalità_pagamento", "categoria_modalità_pagamento": `${eventPaymentType[values.paymentType]}`})
          }}
        >
          {() => (
            <Form
              id={"paymentType"}
              noValidate
              autoComplete={"off"}
              className="payment-type-form"
            >
              <div className="row">
                <div className="col-12">
                  <SwitchRadioField
                    options={[
                      {
                        label: t("cases.analisi_acqua.pre_step_form.bank"),
                        value: PaymentType.BANK,
                        grid: { xs: 12, md: "auto" },
                      },
                    ]}
                    name="paymentType"
                  />
                  <div className="bank-info">
                    <div className="row">
                      <div className="col-4">
                        <TranslatedText i18nKey="cases.analisi_acqua.pre_step_form.accountholder" />
                        :
                      </div>
                      <div className="col-8">
                        <b>
                          {t(
                            "cases.analisi_acqua.pre_step_form.accountholder.info"
                          )}
                        </b>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-4">
                        <TranslatedText i18nKey="cases.analisi_acqua.pre_step_form.iban" />
                        :
                      </div>
                      <div className="col-8">
                        <b>
                          {" "}
                          {t(
                            "cases.analisi_acqua.pre_step_form.iban.info"
                          )}{" "}
                        </b>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-4">
                        <TranslatedText i18nKey="cases.analisi_acqua.pre_step_form.cause" />
                        :
                      </div>
                      <div className="col-8">
                        <b>
                          {" "}
                          {t(
                            "cases.analisi_acqua.pre_step_form.cause.description"
                          )}{" "}
                        </b>
                      </div>
                    </div>
                    <p className="my-5">
                      <TranslatedText i18nKey="cases.analisi_acqua.pre_step_form.note" />
                    </p>
                  </div>

                  <SwitchRadioField
                    options={[
                      {
                        label: t("cases.analisi_acqua.pre_step_form.credit_card"),
                        value: PaymentType.CREDIT_CARD,
                        grid: { xs: 12, md: 8 },
                      },
                    ]}
                    name="paymentType"
                  />
                </div>
              </div>
              <Button className="continue-button" type="submit">
                {t("cases.buttons.continue")}
              </Button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default PreForm;
